import { AlertTriangle } from 'lucide-react';
import { useRuntimeConfig } from '../lib/runtime-config.js';

/**
 * Simulator mode must be impossible to miss. A staff member looking at a draft
 * needs to know at a glance whether "send" would reach a real customer.
 */
export function SimulatorBanner() {
  const config = useRuntimeConfig();
  if (!config.simulatorEnabled) return null;

  return (
    <div
      role="status"
      className="flex items-center gap-2 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        <strong className="font-semibold">Development simulator active.</strong> Shopify, email and
        campaign providers are simulated. Nothing sent from this environment reaches a real
        recipient.
      </span>
    </div>
  );
}

/**
 * A second, quieter indicator for the times a simulator is off but sending is
 * still disarmed — the common state during setup.
 */
export function SendingDisabledNotice() {
  const config = useRuntimeConfig();
  if (config.simulatorEnabled) return null;
  if (config.flags.ALLOW_EXTERNAL_WRITES) return null;

  return (
    <div
      role="status"
      className="flex items-center gap-2 border-b border-slate-300 bg-slate-100 px-4 py-2 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        External sending is disabled. Drafts and approvals work normally; no message will leave the
        platform until an administrator arms sending.
      </span>
    </div>
  );
}
